/**
 * Wishlist Core JS
 * File: assets/wishlist-core.js
 * Include in theme.liquid before </body>:
 *   <script src="{{ 'wishlist-core.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  'use strict';

  function getKey() {
    if (window.FlbWishlist && window.FlbWishlist.KEY) return window.FlbWishlist.KEY;
    var meta = document.querySelector('meta[name="customer-id"]');
    return meta ? 'flb_wl_' + meta.content : 'flb_wl_guest';
  }

  // Always store IDs as numbers for consistent comparison
  function getIds() {
    try {
      var raw = JSON.parse(localStorage.getItem(getKey())) || [];
      return raw.map(function(id) { return typeof id === 'string' && !isNaN(id) ? parseInt(id, 10) : id; });
    } catch(e) { return []; }
  }

  function saveIds(ids) { localStorage.setItem(getKey(), JSON.stringify(ids)); dispatch(ids); }
  function dispatch(ids) { document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: ids } })); }

  function normaliseId(rawId) {
    // Always convert numeric strings to integers for consistent indexOf matching
    if (rawId === undefined || rawId === null) return null;
    return rawId && !isNaN(rawId) ? parseInt(rawId, 10) : rawId;
  }

  function toggle(id) {
    var nid = normaliseId(id);
    var ids = getIds();
    var idx = ids.indexOf(nid);
    var adding = idx === -1;
    if (adding) ids.push(nid); else ids.splice(idx, 1);
    saveIds(ids);

    // Sync to Shopify backend if customer is logged in
    if (document.querySelector('meta[name="customer-id"]')) {
      var endpoint = adding ? 'wishlist-add' : 'wishlist-remove';
      fetch('/apps/wishlist/' + endpoint + '?product_id=' + nid)
        .catch(function(e) { console.error('Wishlist sync failed:', e); });
    }

    return adding;
  }

  function syncBtn(btn) {
    var rawId = btn.dataset.productId || btn.dataset.productHandle;
    var id = normaliseId(rawId);
    if (id === null) return;
    var saved = getIds().indexOf(id) !== -1;
    btn.classList.toggle('is-wishlisted', saved);
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    var tooltip = btn.querySelector('.wl-tooltip');
    if (tooltip) tooltip.textContent = saved ? 'Remove from wishlist' : 'Add to wishlist';
  }

  function syncAll() {
    document.querySelectorAll('[data-wl-btn]').forEach(syncBtn);
  }

  function bindBtn(btn) {
    if (btn._wlBound) return;
    btn._wlBound = true;
    btn.addEventListener('click', function() {
      var rawId = btn.dataset.productId || btn.dataset.productHandle;
      var id = normaliseId(rawId);
      if (id === null) return;
      toggle(id);
      syncBtn(btn);
      if (btn.classList.contains('wl-icon-btn')) {
        btn.classList.remove('popping');
        void btn.offsetWidth;
        btn.classList.add('popping');
        btn.addEventListener('animationend', function(){ btn.classList.remove('popping'); }, { once: true });
      }
    });
  }

  // Pull saved wishlist from Shopify backend — server is the source of truth,
  // so this replaces localStorage rather than only adding to it. This ensures
  // removals made on another device/browser are correctly reflected here too.
  function mergeFromServer() {
    if (!document.querySelector('meta[name="customer-id"]')) return;
    fetch('/apps/wishlist/wishlist-get')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var serverIds = data.wishlist || [];
        var localIds = getIds();

        var serverSorted = serverIds.slice().sort();
        var localSorted = localIds.slice().sort();

        if (JSON.stringify(serverSorted) !== JSON.stringify(localSorted)) {
          localStorage.setItem(getKey(), JSON.stringify(serverIds));
          dispatch(serverIds);
        }
      })
      .catch(function(e) { console.error('Wishlist merge failed:', e); });
  }

  function init() {
    document.querySelectorAll('[data-wl-btn]').forEach(function(btn){ syncBtn(btn); bindBtn(btn); });
    if (document.body) startObserver();
    mergeFromServer();
  }

  function startObserver() {
    var observer = new MutationObserver(function() {
      document.querySelectorAll('[data-wl-btn]:not([data-wl-bound])').forEach(function(btn) {
        syncBtn(btn); bindBtn(btn); btn.setAttribute('data-wl-bound', 'true');
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('wishlist:updated', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FlbWishlistCore = { getIds: getIds, saveIds: saveIds, toggle: toggle, syncAll: syncAll };
})();